import { BonusType } from '@superbet-group/web.types';

import { Condition } from '@app/promotionHub/shared/types/Condition';
import { useI18n } from '@superbet-group/web.lib.vue-utilities';
import { SharedCustomContentConditions } from '@app/promotionHub/shared/types/CustomContent';
import { translationBoldFormat } from '@superbet-group/web.lib.utilities';

export const GameProvider = {
    LightAndWonder: 'Light and Wonder',
} as const;
export type GameProvider = typeof GameProvider[keyof typeof GameProvider];

export function getBonusCardTypeName(type: BonusType, provider?: string) {
    if (type === BonusType.FreeSpins && provider && provider === GameProvider.LightAndWonder) {
        return 'bonus.active.tag_light_and_wonder';
    } else {
        return displayName[type];
    }
}

export function getBonusCardIcon(type: BonusType) {
    return iconImage[type];
}

/**
 * iCore already returns condition value with marked bold section so we don't need to additionally parse it
 */
export function getCustomContentLabel(customCondition: Condition) {
    const { translate } = useI18n();

    if (customCondition.type === SharedCustomContentConditions.sharedTermsAndConditions) {
        return `<b>${translate(customCondition.value)}</b>`;
    } else if (!customCondition.label
        && customCondition.type !== SharedCustomContentConditions.sharedExpirationDate) {
        return translationBoldFormat(translate(customCondition.value));
    } else {
        return `
            ${customCondition.label ? translationBoldFormat(translate(customCondition.label)) : ''}
            <b>${translate(customCondition.value)} 
            ${customCondition.type === SharedCustomContentConditions.sharedBetTotalOff ? translate('currencyAbbreviation') : ''}</b>
        `;
    }
}

type DisplayName =
    | ''
    | 'bonus.active.tag_sport'
    | 'bonus.active.tag_free_bet'
    | 'bonus.active.tag_casino'
    | 'bonus.active.tag_free_spin'
    | 'bonus.active.tag_virtual'
    | 'cash'
    | 'bonus.active.tag_bingo'
    | 'bonus.active.tag_live_dealer';

const displayName: Record<BonusType, DisplayName> = {
    [BonusType.Sport]: 'bonus.active.tag_sport',
    [BonusType.Freebet]: 'bonus.active.tag_free_bet',
    [BonusType.Casino]: 'bonus.active.tag_casino',
    [BonusType.FreeSpins]: 'bonus.active.tag_free_spin',
    [BonusType.Virtuals]: 'bonus.active.tag_virtual',
    [BonusType.CasinoVirtuals]: 'bonus.active.tag_virtual',
    [BonusType.Cash]: 'cash',
    [BonusType.Bingo]: 'bonus.active.tag_bingo',
    [BonusType.LiveDealer]: 'bonus.active.tag_live_dealer',
    [BonusType.HoneyToken]: '',
};

type IconImage =
    | 'games-slot'
    | 'games-casino-coin'
    | 'sports-soccer'
    | 'games-horse'
    | 'games-bingo'
    | 'games-live-casino'
    | 'commerce-coupon';

const iconImage: Record<BonusType, IconImage> = {
    [BonusType.FreeSpins]: 'games-casino-coin',
    [BonusType.Casino]: 'games-casino-coin',
    [BonusType.Sport]: 'sports-soccer',
    [BonusType.Freebet]: 'sports-soccer',
    [BonusType.Virtuals]: 'games-horse',
    [BonusType.CasinoVirtuals]: 'games-casino-coin',
    [BonusType.Cash]: 'games-casino-coin',
    [BonusType.Bingo]: 'games-bingo',
    [BonusType.LiveDealer]: 'games-live-casino',
    [BonusType.HoneyToken]: 'commerce-coupon',
};
